import {
  TAGS_INDEX_REQUESTED,
  TAGS_INDEX_SUCCESS,
  TAGS_INDEX_FAILURE,
} from '../types';

const INITIAL_STATE = {
  tags: [],
  isFetching: false,
  status: 'waiting',
  errors: null
};

const tags = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case TAGS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case TAGS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        tags: action.payload.tags || [],
        isFetching: false,
        status: 'success',
        errors: null
      });

    case TAGS_INDEX_FAILURE:
      return Object.assign({}, state, {
        tags: [],
        isFetching: false,
        status: 'error',
        errors: 'The store tags could not be loaded. Check your connection and try again.'
      });

    default:
      return state;
  }
}

export default tags;
